import ClearingAPI from '@shared/api';

export const {
    transferReports: { getReserves },
} = ClearingAPI.settings;
